@if (resetPasswordSuccess()) {
  <p>{{ 'jobboard.platform.auth.reset-password.success-message' | transloco }}</p>
} @else {
  <form [formGroup]="resetPasswordForm" (ngSubmit)="onResetPasswordFormSubmit()">
    <div class="form-group" [class.invalid]="email.invalid && resetPasswordFormSubmitAttempt">
      <input
        class="form-control"
        type="email"
        [placeholder]="'jobboard.platform.auth.reset-password.email' | transloco"
        [formControl]="email"
      />
      <div class="validation">
        @if (email.errors?.['required']) {
          <p>{{ 'ct-library.validation.required' | transloco }}</p>
        }
        @if (email.errors?.['email'] || email.errors?.['pattern']) {
          <p>{{ 'ct-library.validation.email' | transloco }}</p>
        }
      </div>
    </div>
    <div class="form-group captcha-group" [class.invalid]="captchaCode.invalid && resetPasswordFormSubmitAttempt">
      <ct-lib-friendly-captcha
        [control]="captchaCode"
        [class.invalid]="resetPasswordFormSubmitAttempt && captchaCode.invalid"
        [startMode]="'auto'"
      />
    </div>
    <app-button htmlType="submit" [loading]="resetPasswordFormSubmitting" [fullWidth]="true">
      {{ 'jobboard.platform.auth.reset-password.submit' | transloco }}
    </app-button>
  </form>
}
